import React, { useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import moment from 'moment-timezone'
import { addDays, startOfDay } from 'date-fns'
import { Box, Button, DatePicker, Field, Flex } from '@workwhile/ui'
import { useUserEventLogsQuery } from 'queries/user'
import { getEventLogsColumns } from '../Shared/eventLogs'
import { User } from '../Shared/common_defs'

interface Props {
  user: User
}

interface DateRange {
  from: Date | undefined
  to?: Date | undefined
}

const DEFAULT_RANGE: DateRange = {
  from: addDays(new Date(), -7),
  to: new Date(),
}

function toApiTimestamps(range: DateRange) {
  if (!range.from || !range.to) return null
  return {
    startsAt: startOfDay(range.from).toISOString(),
    endsAt: addDays(startOfDay(range.to), 1).toISOString(),
  }
}

const UserEventLog = ({ user }: Props) => {
  const timezone =
    user && user.address ? user.address.timezone : moment.tz.guess(true)
  const eventLogsColumns = getEventLogsColumns(timezone)

  const [pickedRange, setPickedRange] = useState<DateRange>(DEFAULT_RANGE)
  const [committedRange, setCommittedRange] = useState<DateRange>(DEFAULT_RANGE)

  const committedTimestamps = toApiTimestamps(committedRange)
  const userId = user.id ? Number(user.id) : undefined

  const { data: eventLogs, isFetching } = useUserEventLogsQuery(
    {
      userId: userId ?? 0,
      startsAt: committedTimestamps?.startsAt ?? '',
      endsAt: committedTimestamps?.endsAt ?? '',
    },
    { enabled: !!userId && !!committedTimestamps }
  )

  const handleSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault()
    if (!pickedRange.from || !pickedRange.to) {
      window.alert('Please enter both a start date and end date')
      return
    }
    if (!userId) {
      window.alert('User ID is required')
      return
    }
    setCommittedRange(pickedRange)
  }

  return (
    <Box>
      <Field label="See events between">
        <Flex>
          <DatePicker
            placeholder="Select date ranges to see events"
            mode="range"
            selected={pickedRange}
            onSelect={(range) => setPickedRange(range as DateRange)}
          />
        </Flex>
      </Field>
      <Box mb={3}>
        <Button width={150} loading={isFetching} onClick={handleSubmit}>
          View Logs
        </Button>
      </Box>
      {eventLogs && eventLogs.length > 0 ? (
        <BootstrapTable
          striped
          keyField="timestamp"
          data={eventLogs}
          columns={eventLogsColumns}
          rowStyle={{ fontSize: 11 }}
        />
      ) : (
        !isFetching && <p>No events found for this user.</p>
      )}
      <hr />
    </Box>
  )
}

export default UserEventLog
